/**
 * `<view-header>` — Page-level heading for a view section.
 *
 * Renders a styled `<h1>` with the default slot as content.
 *
 * @slot - Heading text.
 */

import { css, html, LitElement, type TemplateResult } from "lit";
import { customElement } from "lit/decorators.js";
import { base } from "../../design-system/index.ts";

const hostStyles = css`
  :host {
    display: block;
  }

  h1 {
    font-size: var(--font-size-xl);
    font-weight: var(--font-weight-semibold);
    color: var(--foreground);
    line-height: var(--line-height-tight);
    margin-bottom: var(--space-8);
  }
`;

@customElement("view-header")
export class ViewHeaderElement extends LitElement {
  static override styles = [base, hostStyles];

  override render(): TemplateResult {
    return html`<h1><slot></slot></h1>`;
  }
}

declare global {
  interface HTMLElementTagNameMap {
    "view-header": ViewHeaderElement;
  }
}
